import React from 'react';
export const ListContext = React.createContext({});
export const ListConsumer = ListContext.Consumer;
